import { Component, ElementRef, Input, OnChanges, Renderer2 } from "@angular/core";
import { NgStyle } from "@angular/common";

@Component({
    selector: "[pcg-ng-skeleton-loader]",
    template: "",
    host: {
        "[class.pcg-skeleton]": "true"
    },
    imports: [
        NgStyle
    ],
    standalone: true
})
export class SkeletonLoaderComponent implements OnChanges {
    @Input() public width: string = "100%";
    @Input() public height: string = "24px";

    public constructor(
        private el: ElementRef,
        private renderer: Renderer2
    ) {
    }

    public ngOnChanges(): void {
        this.renderer.setStyle(this.el.nativeElement, "width", this.width);
        this.renderer.setStyle(this.el.nativeElement, "height", this.height);
    }
}
